'use strict';

angular.module('systemOwnerControllers')

.directive('systemOwnerCard', [function () {
    return {
        scope: {
            systemOwner: '=',
            readOnly: '=',
            layoutRatio: '=?',
            toRemoveBackup: '&',
            toChangePrimary: '&'
        },
        restrict: 'AE',
        templateUrl: require('./SystemOwnerCard.tpl.html'),
        controller: ['$scope', function ($scope) {

            // Display or not actions
            $scope.displayActions = false;
            $scope.isRemovedSystemOwner = false;

            $scope.showOrHideActions = function ($event) {
                if ($scope.readOnly) return;
                $scope.displayActions = !$scope.displayActions;
                $event.stopPropagation();
            }

            // Remove backup system owner
            $scope.removeBackup = function () {
                $scope.toRemoveBackup().then(function () {
                    $scope.isRemovedSystemOwner = true;
                });
            }

            // Change primary system owner
            $scope.changePrimary = function () {
                $scope.toChangePrimary();
            }
        }],
        link: function (scope, element, attrs) {

            scope.layoutRatio = scope.layoutRatio ? scope.layoutRatio : {
                column: 'col-md-4'
            };
        }
    };
}]);